module.exports = __webpack_public_path__ + "img/ic_team_instagram.bc242bc2.svg";